import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'atw-units-config',
  templateUrl: './units-config.component.html',
  styleUrls: ['./units-config.component.scss']
})
export class AtwUnitsConfig implements OnInit {
  @Input() data_tool: any
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() staticdata: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  dataAfterChange: any = {};
  id_project: any;
  tabs = ['Kiểu 1', 'Kiểu 2', 'Kiểu 3'];
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {}; // biến xác định mở rộng tất cả hay theo thuộc tính
  fonts = [];

  styles_field = [
    {
      title: 'Điều chỉnh viền kiểu 1',
      index: 1,
    },
    {
      title: 'Điều chỉnh viền kiểu 2',
      index: 2,
    },
    {
      title: 'Điều chỉnh viền kiểu 3',
      index: 3,
    },
  ];

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhEventMediator: VhEventMediator,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    forkJoin([
      this.http.get('assets/fonts/fonts.json')
    ]).subscribe(([fonts]: any) => {
      this.fonts = fonts;
    })
  }

  /**Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
  };
  /** Chọn kiểu units
   * @param index : Xác định kiểu unit
   * Ví dụ: kiểu 1 hoặc kiểu 2
   */
  chooseUnits(index) {
    if (index == 0) {
      this.config.units_type = 0;
    }
    else if (index == 1) {
      this.config.units_type = 1;
    }
    else {
      this.config.units_type = 2;
    }
    this.updateObject()
  }

  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config })
      .then((bool: any) => {
        
      })
    // this.cdRef.detectChanges()
  }

  /**
   * update trường mobile_portrait_hidden or desktop_hidden cho object
   * @param value
   */
  updateHidden(value) {
    this.vhQueryAutoWeb.updateObject(this.data_tool._id, value)
      .then((bool) => {
        
      }, error => {
        console.error(error)
      })
  }

  // cập nhật border right khi border top thay đổi màu
  updateBorderColor() {
    const color = this.class['+units-check__items--before']['border-top-color'];
    this.class['+units-check__items--before']['border-right-color'] = color;
  }
  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['units']['width'] = event.width + 'px';
    if (event.height) this.class['units']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateObject()
  }

  /**
 * Hàm này dùng để mở rộng phần cấu hình.
 * @param field_text : trả về phần tử được chọn của mảng style_field
 */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  updateStaticData() {
    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
        // console.log('updateObject', bool);
      });
  }



}

